
import './App.css';
import Counter from './Components/Counter';
function App() {
  return (
    <div className="App">
      <Counter/>
    </div>
  );
}

export default App;
